// HELPERS
import {createClassName} from "@helpers/utils";
import React from "react";

import ContentBox from "@components/ContentBox/ContentBox";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import fulfillment from "./IntroBackground.fulfillment";
import OptionsList from "../../../components/OptionsList/OptionsList.jsx";
import TextField from "../../../../../components/TextField/TextField.jsx";
import TextView from "../../../../../components/TextView/TextView.jsx";
import Select from "../../../../../components/Select/Select.jsx";

export default class IntroBackground extends React.PureComponent
{
	state = _getInitialState.call(this);
	fields = _getFields.call(this);

	customerSources = [
		{
			value: "Uppringd av Fair",
			label: "Uppringd av Fair"
		},
		{
			value: "Deltagit på event",
			label: "Deltagit på event"
		},
		{
			value: "Via rekommendation",
			label: "Via rekommendation"
		},
		{
			value: "Via hemsidan",
			label: "Via hemsidan"
		},
		{
			value: "Övrigt",
			label: "Övrigt"
		}
	];

	static helpCompanyOptions = [
		{value: "Aktieinvest",  label: "Aktieinvest"},
		{value: "Avanza",  label: "Avanza"},
		{value: "Carnegie",  label: "Carnegie"},
		{value: "Cliens",  label: "Cliens"},
		{value: "Danske Bank",  label: "Danske Bank"},
		{value: "DNB",  label: "DNB"},
		{value: "East Capital",  label: "East Capital"},
		{value: "Handelsbanken",  label: "Handelsbanken"},
		{value: "Max Matthiessen",  label: "Max Matthiessen"},
		{value: "Nordea",  label: "Nordea"},
		{value: "Nordnet",  label: "Nordnet"},
		{value: "PAM Capital",  label: "PAM Capital"},
		{value: "SEB",  label: "SEB"},
		{value: "Söderbergh & Partners",  label: "Söderbergh & Partners"},
		{value: "Ålandsbanken",  label: "Ålandsbanken"},
		{value: "Annat",  label: "Annat"}
	];

	customerExpectations = [
		{
			value: "Veta mer om Fair",
			label: "Veta mer om Fair"
		},
		{
			value: "Få en bättre lösning för sparande",
			label: "Få en bättre lösning för sparande"
		},
		{
			value: "Få alternativ för min tjänstepension",
			label: "Få alternativ för min tjänstepension"
		}
	];

	isFulfilled(state)
	{
		return fulfillment(state, this.state);
	}

	setCustomerState(customerState, callbackFn)
	{
		customerState = {...this.state.customerState, ...customerState};
		this.setState({
			customerState,
			isFulfilled: this.isFulfilled({customerState})
		}, () =>
		{
			this.props.setAppState({viewFulfilled: this.state.isFulfilled});
			if (callbackFn)
			{
				callbackFn();
			}
		});
	}

	componentDidMount()
	{
		const {setAppState} = this.props;

		// Set navigation events
		setAppState({
			viewFulfilled: this.isFulfilled(),
			showValidationWarning: false,
			navigationButtons: {
				sharing: {},
				back: {disabled: true},
				next: {
					onClick: () =>
					{
						if (this.state.isFulfilled === true)
						{
							return;
						}
						this.setState({hasFormValidationErrors: true});
						return setAppState({showValidationWarning: true});
					}
				}
			}
		});
	}

	render()
	{
		const {customerState, readOnly} = this.state;
		const hasFormValidationErrors = !this.state.isFulfilled && this.state.hasFormValidationErrors;
		const classes = createClassName("Cob-view Cob-view2", {});

		return (
			<div className={classes}>
				<DefaultFields fields={this.fields}/>

				<ContentBox>
					<h2>Frågor inför mötet</h2>

					<div className="Cob-view2-fields">
						<OptionsList
							style={{marginBottom: "0"}}
							type="radio"
							description={"Har kunden hjälp idag?"}
							name="radio_customer_has_help"
							value={customerState.radio_customer_has_help}
							options={[
								{
									label: "Nej",
									value: "no",
									checked: customerState.radio_customer_has_help === "no"
								},
								{
									label: "Ja",
									value: "yes",
									checked: customerState.radio_customer_has_help === "yes"
								}
							]}
							onChange={(checked, radio_customer_has_help) => this.setCustomerState({radio_customer_has_help})}
							validation={(value) => ((value && value.length > 0) || false)}
							highlightErrors={hasFormValidationErrors}
							readOnly={readOnly}
						/>

						{customerState.radio_customer_has_help === "yes" && (
							<React.Fragment>
								<p className={"field-label with-previous"}>
									Vilken aktör har kunden hjälp av idag?
								</p>
								<Select
									name="customer_current_help"
									label={"Välj"}
									selectedIndex={IntroBackground.helpCompanyOptions.map(c => c.value).indexOf(customerState.customer_current_help)}
									options={IntroBackground.helpCompanyOptions}
									onChange={(option) =>
									{
										this.setCustomerState({customer_current_help: option.value});
									}}
									highlightErrors={hasFormValidationErrors}
									readOnly={readOnly}
								/>
							</React.Fragment>
						)}

						<p className={"field-label"}>
							Hur har kunden kommit in till dagens möte?
						</p>
						<Select
							name="customer_current_source"
							label={"Välj"}
							selectedIndex={this.customerSources.map(c => c.value).indexOf(customerState.customer_current_source)}
							options={this.customerSources}
							onChange={(option) =>
							{
								this.setCustomerState({customer_current_source: option.value});
							}}
							readOnly={readOnly}
						/>

						{customerState.customer_current_source === "Övrigt" && (
							<React.Fragment>
								<TextField
									name={"customer_current_source_other"}
									value={customerState.customer_current_source_other}
									label="Ange hur kunden kom in till mötet"
									onChange={({target}) => this.setCustomerState({customer_current_source_other: target.value})}
									validation={value => value.length > 0}
									highlightErrors={hasFormValidationErrors}
									readOnly={readOnly}
								/>
							</React.Fragment>
						)}
						<input type={"hidden"} name={"customer_current_source_form"}
						       value={customerState.customer_current_source === "Övrigt" ?
							       customerState.customer_current_source_other :
							       customerState.customer_current_source} />

						<p className={"field-label"}>
							Vad har kunden för förväntningar på dagens möte?
						</p>
						<Select
							name="customer_current_expectations"
							label={"Välj"}
							selectedIndex={this.customerExpectations.map(c => c.value).indexOf(customerState.customer_current_expectations)}
							options={this.customerExpectations}
							onChange={(option) =>
							{
								this.setCustomerState({customer_current_expectations: option.value});
							}}
							readOnly={readOnly}
						/>

						<p className={"field-label"}>
							Är det något annat kunden tycker är viktigt att vi går igenom under mötet?
						</p>

						<TextView
							name="customer_current_concerns"
							label={`Fritext (${1800 - customerState.customer_current_concerns.length} tecken kvar)`}
							value={customerState.customer_current_concerns}
							maxLength={1800}
							validation={value => value.length > 0}
							resize="vertical"
							onChange={({target}) => this.setCustomerState({customer_current_concerns: target.value})}
							fullWidth
							minHeight={250}
							readOnly={readOnly}
						/>
					</div>
				</ContentBox>
				<input type={"hidden"} name={"date"} value={customerState.date} />
			</div>
		);
	}
}

// PRIVATE FUNCTIONS
function _getInitialState()
{
	const {customer, viewNo, hasFormValidationErrors, readOnly} = this.props;
	const seenViews = JSON.parse(localStorage.getItem(`SEEN_VIEWS_${btoa(customer.caseId)}`)) || [];
	const hasBeenSeen = (seenViews.includes(viewNo));

	// if it hasn't been seen add the view to local storage for the specific case
	if (customer.caseId && !hasBeenSeen)
	{
		localStorage.setItem(`SEEN_VIEWS_${btoa(customer.caseId)}`, JSON.stringify([...seenViews, viewNo]));
	}

	let newState = getViewInitialStateForCustomer(customer);
	newState.isFulfilled = this.isFulfilled(newState);
	newState.hasFormValidationErrors = hasBeenSeen || hasFormValidationErrors;
	newState.readOnly = readOnly;
	return newState;
}

export function getViewInitialStateForCustomer(customer)
{
	let newState = {
		isFulfilled: false,
		isLoading: true,
		lookupNotFound: false,
		fraudFlag: false,
		errorMessage: null,
		customerState: {
			date: customer.getData("date") || "",
			radio_customer_has_help: customer.getData("radio_customer_has_help", ""),
			customer_current_help: customer.getData("customer_current_help", ""),
			customer_current_concerns: customer.getData("customer_current_concerns", ""),
			customer_current_source: customer.getData("customer_current_source", ""),
			customer_current_source_other: customer.getData("customer_current_source_other", ""),
			customer_current_expectations: customer.getData("customer_current_expectations", "")
		}
	};

	if (newState.customerState.date === "")
	{
		const today = new Date();
		let dayDate = today.getDate() < 10 ? "0" + today.getDate() : today.getDate();
		let monthDate = (today.getMonth() + 1) < 10 ? "0" + (today.getMonth() + 1) : (today.getMonth() + 1);
		newState.customerState.date = today.getFullYear() + '-' + monthDate + '-' + dayDate;
	}

	return newState;
}

function _getFields()
{
	return [
		"radio_customer_has_help",
		"customer_current_help",
		"customer_current_concerns",
		"customer_current_source",
		"customer_current_source_other",
		"customer_current_expectations"
	];
}